export function callParamsFromUrl() {
  const params = new URLSearchParams(window.location.search);

  return {
    url: params.get('url') ? decodeURIComponent(params.get('url')) : null,
    token: params.get('token') || null,
    userName: params.get('userName') || null,
  };
}

export function pageUrlFromRoomUrl(roomUrl, token, userName) {
  const baseUrl = window.location.href.split('?')[0];
  const params = new URLSearchParams();

  if (roomUrl) params.set('url', encodeURIComponent(roomUrl));
  if (token) params.set('token', token);
  if (userName) params.set('userName', userName);

  return `${baseUrl}?${params.toString()}`;
}
